'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _searchbar = require('./searchbar');

var _searchbar2 = _interopRequireDefault(_searchbar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _searchbar2.default; /**
                                        * Created by n7best.
                                        */

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/lib/components/searchbar/index.js
// module id = 1796
// module chunks = 7